import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'firstName',
    standalone: false
})
export class FirstNamePipe implements PipeTransform {
  public transform(fullName: string): string {
    if (!fullName) return ''
    return fullName.split(' ')[0]
  }
}
